export const GET_MAIN_CONTACTS = 'GET_MAIN_CONTACTS';
export const SELECT_CONTACT = 'SELECT_CONTACT';
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const REMOVE_CONTACT = 'REMOVE_CONTACT';
export const SET_IS_LOADING_CONTACTS = 'SET_IS_LOADING_CONTACTS';
